/**
 * Die Belege hinter den Zahlen: Buchungen, Ausgaben-Belege und laufende Verträge.
 */
import { useState } from 'react';
import { Card, CardBody, SegmentedControl } from '@/shared/components';
import { formatNumber } from '@/shared/lib/format';
import type { BookingResponse, ExpenseListItem, RecurringCostLine } from '@/shared/api';
import { BookingsList, ExpensesList, RecurringList } from './DrilldownLists';

type Tab = 'bookings' | 'expenses' | 'recurring';

interface Props {
  bookings: BookingResponse[];
  expenses: ExpenseListItem[];
  recurringLines: RecurringCostLine[];
  currency: string;
}

export function DrilldownTabs({ bookings, expenses, recurringLines, currency }: Props) {
  const [tab, setTab] = useState<Tab>('bookings');

  return (
    <Card>
      <CardBody className="p-4 sm:p-5">
        <SegmentedControl
          value={tab}
          onChange={(value) => setTab(value as Tab)}
          options={[
            { value: 'bookings', label: `Buchungen (${formatNumber(bookings.length)})` },
            { value: 'expenses', label: `Belege (${formatNumber(expenses.length)})` },
            { value: 'recurring', label: `Verträge (${formatNumber(recurringLines.length)})` },
          ]}
        />
        <div className="mt-4">
          {tab === 'bookings' && <BookingsList bookings={bookings} />}
          {tab === 'expenses' && <ExpensesList expenses={expenses} />}
          {tab === 'recurring' && <RecurringList lines={recurringLines} currency={currency} />}
        </div>
      </CardBody>
    </Card>
  );
}
